import { axiosInstance } from '@/lib/axios'
import { UploadFileProps } from './types'
import { FileProcessingStatus } from '../status'

export function uploadFiles({
  companyId,
  files, // FormData
  lastChunk,
  count,
  taskId,
  extensions,
  signal,
}: UploadFileProps) {
  return axiosInstance.post<FileProcessingStatus>(
    `/api/${companyId}/fileProcessing`,
    files,
    {
      params: {
        lastChunk,
        count,
        taskId,
        extensions: extensions.join(','), // "jpg,pdf,tar.gz"
      },
      signal,
    },
  )
}
